import React, { useState } from "react";
import { Col,Row,Accordion,AccordionItem,AccordionHeader,AccordionBody} from "reactstrap";

import withRouter from "../../Components/Common/withRouter";

const FAQ = () => {
  const [openLeftIcon, setOpenLeftIcon] = useState("1");
  const toggleLeftIcon = (id: any) => {
    if (openLeftIcon !== id) {
      setOpenLeftIcon(id);
    }
  };

  document.title = "FAQ | Business Online";
  return (
    <React.Fragment>
        <Row className="g-0 auth-container">
          <Col lg={12} xs={12}>
            <div className="faq-bloc">
            <div>
                <h2>F.A.Q</h2>
            </div>
            <div className="mt-4">
                <Accordion className="lefticon-accordion custom-accordionwithicon accordion-border-box" open={openLeftIcon} toggle={toggleLeftIcon}>
                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="1">
                    QU’EST-CE QUE BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                    <p>
                        BUSINESS ONLINE est un portail e-Banking Cash
                        Management &amp; Trade Finance , couvrant une large
                        gamme de services et de fonctionnalités , compétitive
                        sur la place et en continuel enrichissement selon vos
                        besoins et en fonction des évolutions technologiques
                        en la matière.
                    </p>
                    <p>
                        Il a pour objectif d’améliorer la gestion au quotidien
                        des entreprises clientes dans le cadre de leurs
                        activités et transactions domestiques et de commerce
                        extérieur.
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="2">
                    A QUI S’ADRESSE LE PORTAIL BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="2">
                    <p>
                        Le portail BUSINESS ONLINE s’adresse aux entreprises
                        clientes de BANK OF AFRICA qui souhaitent automatiser
                        et digitaliser les opérations Cash et/ou Trade,
                        qu’elles effectuent manuellement et soumettent
                        aujourd’hui via canal physique à la banque .
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="3">
                    COMMENT SOUSCRIRE AU PORTAIL BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="3">
                    <p>
                        La souscription au portail se fait auprès de la
                        banque.
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="4">
                    COMMENT ACCEDER AU PORTAIL BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="4">
                    <p>
                        Le portail BUSINESS ONLINE est accessible à partir de l’adresse <a href="www.businessonline.ma">www.businessonline.ma</a> ou à partir du site institutionnel de BANK OF AFRICA <a href="www.bankofafrica.ma">www.bankofafrica.ma</a>
                    </p>
                    <p>
                        Les abonnés du portail accèdent à la plateforme via :
                    </p>
                    <ul>
                        <li>
                        Un Identifiant de l’utilisateur (LOGIN) communiqué
                        par mail à chaque abonné ;
                        </li>
                        <li>
                        Un Mot de passe à usage unique (OTP) généré par le
                        client sur l’application B‘SIGN.
                        </li>
                    </ul>
                    Le parcours BUSINESS ONLINE CASH est accessible via web
                    et via l’application Mobile téléchargeable sur les
                    stores.
                    <p></p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="5">
                    EST-CE QUE LE PORTAIL BUSINESS ONLINE EST SECURISE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="5">
                    <p>
                        Le portail BUSINESS ONLINE est hautement sécurisé à
                        travers la mise en place d’une authentification forte
                        en faveur des utilisateurs et des signataires.
                    </p>

                    <p>
                        De plus, l’authentification au portail BUSINESS ONLINE
                        , la validation de toutes les transactions est soumise
                        à la forte authentification à travers B’SIGN.
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="6">
                    QU’EST-CE L’APPLICATION B’SIGN ?
                    </AccordionHeader>
                    <AccordionBody accordionId="6">
                    <p>
                        B’Sign est une application mobile conçue afin de
                        sécuriser vos opérations en ligne.
                    </p>
                    <p>
                        Elle vous permet de générer des OTP (One Time
                        Password) qui consiste en un mot de passe à usage
                        unique pour la connexion au niveau du portail BUSINESS
                        ONLINE ainsi que la validation de toutes vos
                        transactions.
                    </p>
                    <p>
                        B’Sign est une application hautement sécurisée et
                        protégée à travers un code PIN ou une authentification
                        biométrique.
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="7">
                    QUELS SONT LES PARCOURS DISPONIBLES VIA LE PORTAIL
                    BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="7">
                    <p></p>
                    <ul>
                        <li>PARCOURS CASH</li>
                        <li>PARCOURS TRADE</li>
                        <li>PARCOURS CUSTODY DIRECT</li>
                        <li>PARCOURS OPCVM DIRECT</li>
                    </ul>
                    <p></p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="8">
                    QUELLES SONT LES FONCTIONNALITES DE CONSULTATION
                    PROPOSEES PAR BUSINESS ONLINE CASH ?
                    </AccordionHeader>
                    <AccordionBody accordionId="8">
                    <p>
                        BUSINESS ONLINE CASH fournit une vision consolidée de
                        l’ensemble des comptes de l’entreprise en temps réel,
                        multi-comptes et multi-sociétés.
                        <br />
                        Vous disposez au niveau du portail des fonctionnalités
                        complètes en terme de consultation et de reporting :
                    </p>
                    <p></p>
                    <ul>
                        <li>Consultations des comptes en temps réel</li>
                        <li>
                        Consultation de la situation des comptes (solde
                        disponible, solde comptable, opérations à venir, …)
                        </li>
                        <li>Recherche des mouvements sur les comptes</li>
                        <li>
                        Relevé des comptes à télécharger sous différents
                        formats : PDF (relevé), Excel (extrait) et à venir :
                        ETEBAC et MT940
                        </li>
                        <li>Edition de RIB</li>
                        <li>
                        Document client (+ de 30 types d’avis d’opérés
                        disponibles)
                        </li>
                        <li>
                        Consultation DAT (type / montant / date d’échéance /
                        date effet / nantissement / taux d’intérêt)
                        </li>
                        <li>Consultation Valeurs (image chèque &amp; LCN)</li>
                        <li>
                        Consultation impayé chèque et LCN (date rejet / date
                        remise / montant / n° remise / motif rejet)
                        </li>
                        <li>Edition du Certificat du Refus de Paiement</li>
                        <li>Consultation des Cartes</li>
                        <li>
                        Fichiers de sort pour les opérations en masse
                        traitées sur le portail
                        </li>
                        <li>
                        Tableau de bord permettant le suivi du statut des
                        opérations initiées via le portail
                        </li>
                    </ul>
                    <p></p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="9">
                    QUELLES SONT LES FONCTIONNALITES TRANSACTIONNELLES
                    PROPOSEES PAR BUSINESS ONLINE CASH ?
                    </AccordionHeader>
                    <AccordionBody accordionId="9">
                    <p>
                        BUSINESS ONLINE CASH vous propose l’initiation à tout
                        moment de toute transaction domestique à travers une
                        saisie unitaire ou un chargement de fichiers :
                    </p>
                    <ul>
                        <li>
                        Gestion des bénéficiaires en unitaire et en masse
                        </li>
                        <li>Virements unitaires</li>
                        <li>Virement multiple</li>
                        <li>Virement RTGS</li>
                        <li>Virement Instantané</li>
                        <li>Paiement de facture</li>
                        <li>Paiement de vignette en masse</li>
                        <li>Remises d’ordres :</li>
                        <ul className="yes">
                        <li>Virement de masse SIMT</li>
                        <li>
                            Virement de masse MT101 (en DH et Multidevises)
                        </li>
                        <li>EBICS Virement de masse</li>
                        <li>Prélèvement de masse SIMT</li>
                        <li>EBICS Prélèvement de masse</li>
                        <li>Mise à Disposition de masse</li>
                        <li>EBICS Mise à Disposition de masse</li>
                        </ul>
                        <li>Demande de chèque et LCN</li>
                    </ul>
                    <p>
                        Toutes les opérations CASH effectuées sur le portail
                        ne nécessitent pas d’ordre signé physiquement par
                        l’entreprise, le process étant totalement
                        dématérialisé et sécurisé.
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="10">
                    QUELS SONT LES SERVICES ET FONCTIONNALITES TRADE
                    PROPOSES PAR LA PLATEFORME ?
                    </AccordionHeader>
                    <AccordionBody accordionId="10">
                    <p>
                        BUSINESS ONLINE TRADE est une plateforme qui s’adresse
                        aux entreprises qui effectuent des opérations de
                        commerce international, aussi bien à l’import qu’à
                        l’export, leur permettant :
                    </p>
                    <ul>
                        <li>
                        Initiation d’ouverture/modification de crédit
                        documentaire import &amp; lettre de crédit stand-by
                        </li>
                        <li>
                        Demande de règlement de remise documentaire import
                        </li>
                        <li>Initiation de remise documentaire export</li>
                        <li>Ordre de transfert</li>
                        <li>Demande de garanties bancaires</li>
                        <li>Demande de financement extérieur</li>
                        <li>
                        Être notifié à distance des crédits documentaires
                        &amp; Lettres de crédit stand-by export, des remises
                        documentaires import et des transferts reçus.
                        </li>
                        <li>
                        Suivre en ligne et en temps réel leurs états
                        d’avancement grâce à de nombreuses fonctionnalités
                        pratiques de consultation et reporting :
                        <ul className="yes">
                            <li>
                            Réception et édition de la copie des messages
                            Swift relatifs à l’ensemble des opérations, et
                            traçabilité des transferts émis jusqu’à crédit
                            du compte du bénéficiaire grâce à Swift GPI ;
                            </li>
                            <li>
                            Tâches en cours, Transactions récentes en
                            attente et Notifications récentes ;
                            </li>
                            <li>
                            Echéancier Trade, Encours par produit,
                            Extraction de tableau de bord ;
                            </li>
                            <li>Cours de change ;</li>
                            <li>Message à la banque sécurisé, etc</li>
                        </ul>
                        </li>
                    </ul>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="11">
                    LES TRANSACTIONS INITIEES SUR BUSINESS ONLINE TRADE
                    SONT-ELLES TOTALEMENT DEMATERIALISEES ?
                    </AccordionHeader>
                    <AccordionBody accordionId="11">
                    <p>
                        La dématérialisation des documents justificatifs d’une
                        transaction Trade est soumise au respect des
                        dispositions réglementaires en la matière.
                    </p>
                    <p>
                        L’Office des Changes permettant l’échange électronique
                        de la majorité des documents justificatifs, les
                        demandes d’opérations initiées sur Business Online
                        s’exécutent donc dans un processus complétement
                        dématérialisé où ces documents sont scannés et joints
                        à toute demande.
                    </p>
                    <p>
                        A l’exclusion des demandes de Transferts Financiers
                        (règlement de prestation de services, …) et de la
                        Remise Documentaire Export et du CREDOC Export pour
                        lesquelles, respectivement, facture originale et jeu
                        de documents originaux doivent être présentés à la
                        banque
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="12">
                    QU’EST-CE QUE CUSTODY DIRECT ?
                    </AccordionHeader>
                    <AccordionBody accordionId="12">
                    <p>
                        A travers le portail Business Online, les clients
                        institutionnels pourront accéder également au portail
                        titres de BMCE Capital, commercialisé sous la marque «
                        CUSTODY Direct »
                    </p>
                    <p>
                        Pour avoir plus d’informations, vous pouvez vous
                        adresser au centre de relation client Entreprise au <strong>0801 008 100</strong> ou via la boite générique <a href="mailto:GTB_CRCE@bankofafrica.ma">GTB_CRCE@bankofafrica.ma</a>
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="13">
                    QU’EST-CE QUE OPCVM DIRECT ?
                    </AccordionHeader>
                    <AccordionBody accordionId="13">
                    <p>
                        A travers le portail Business Online, les clients
                        pourront accéder à OPCVM Direct pour faire des
                        simulations d’investissement, passer des ordres de
                        souscription et de rachat en ligne, suivre en temps
                        réel le portefeuille de placement, consulter les
                        reportings
                    </p>
                    <p>
                        Pour avoir plus d’informations, vous pouvez vous
                        adresser au centre de relation client Entreprise au <strong>0801 008 100</strong> ou via la boite générique <a href="mailto:GTB_CRCE@bankofafrica.ma">GTB_CRCE@bankofafrica.ma</a>
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="14">
                    COMMENT SONT SIGNEES LES OPERATIONS SUR LE PORTAIL
                    BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="14">
                    <p>
                        La validation des opérations est électronique et se
                        fait en ligne au niveau du portail via l’application
                        B’SIGN, et ce, en respectant la matrice de signature
                        définie sur la fiche d’implémentation (selon les
                        pouvoirs de signature) déposés au niveau de la banque.
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="15">
                    QUE FAIRE EN CAS DE PROBLEME RENCONTRE SUR LE PORTAIL
                    BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="15">
                    <p>
                        Vous devez vous assurer que vous disposez d’une
                        connexion internet, et que vos données
                        d’indentification sont correctes.
                        <br />
                        Le cas échéant, et si le problème persiste vous pouvez
                        vous adresser au centre de relation client Entreprise
                        au <strong>0801 008 100</strong> ou via la boite générique <a href="mailto:GTB_CRCE@bankofafrica.ma">GTB_CRCE@bankofafrica.ma</a>
                    </p>
                    </AccordionBody>
                </AccordionItem>

                <AccordionItem className="material-shadow">
                    <AccordionHeader targetId="16">
                    QUELLE EST LA TARIFICATION DU PORTAIL BUSINESS ONLINE ?
                    </AccordionHeader>
                    <AccordionBody accordionId="16">
                    <p>
                        Les frais d’abonnement au PORTAIL BUSINESS ONLINE est
                        en fonction de la formule choisie :
                    </p>
                    <ul>
                        <li>
                        Formule BUSINESS ONLINE CASH : 200 Dh HT/ mois
                        </li>
                        <li>
                        Formule BUSINESS ONLINE CASH &amp; TRADE : 450 Dh
                        HT/ mois
                        </li>
                        <li>
                        Les portails, OPCVM DIRECT et CUSTODY DIRECT seront
                        offerts gratuitement.
                        </li>
                    </ul>
                    <p>
                        Un prélèvement unitaire du compte du client, de la
                        commission à l’issue de l’exécution de chaque
                        transaction est selon la tarification en vigueur
                    </p>
                    <p>
                        Par ailleurs, les frais de dossiers relatifs aux
                        opérations TRADE de Transfert Emis, Crédit
                        Documentaire Import et Remise Documentaire Export,
                        sont exonères.
                    </p>
                    </AccordionBody>
                </AccordionItem>

                </Accordion>
            </div>
            </div>
          </Col>
        </Row>
    </React.Fragment>
  );
};

export default withRouter(FAQ);
